import { useCallback } from 'react';

import { useSearchActions, useSearchState } from '#src/app/pages/search/shared/searchState';

type Result = ModelHookResult<
	{
		hideButton: boolean;
	},
	{
		clearRefine: () => void;
	}
>;

export function useClearLocationFilter(): Result {
	const state = useSearchState();
	const actions = useSearchActions();

	const hasLocation = state.locationCities.length > 0 || state.locationCountries.length > 0;

	return {
		data: {
			hideButton: !hasLocation,
		},
		actions: {
			clearRefine: useCallback(() => {
				actions.clearLocation();
			}, [actions]),
		},
	};
}
